import { formatLocation, type LocationSlug } from "@/lib/provinces";
import type { Locale } from "@/lib/locale";

// Compact city labels for space-constrained surfaces (directory cards), where
// the full disambiguated "Ho Chi Minh City" is too long and squeezes the rest
// of the meta row. Only the notably-long names are abbreviated; every other
// province falls through to the full `formatLocation` label. Full surfaces
// (profile hero, search sidebar, JSON-LD) keep the long form.
//
// FR has no separate abbreviation — it falls back to the EN one (matches the
// app-wide FR→EN location-label fallback).
const SHORT_LABELS: Record<string, Partial<Record<Locale, string>>> = {
  "ho-chi-minh": { en: "HCMC", vi: "TP.HCM" },
};

/** Like `formatLocation`, but returns a compact label for long city names on cards. */
export function formatLocationShort(slug: LocationSlug, locale: Locale): string {
  const short = SHORT_LABELS[slug]?.[locale] ?? SHORT_LABELS[slug]?.en;
  return short ?? formatLocation(slug, locale);
}
